export default __webpack_public_path__ + "static/mercado_logo-ece02a048b8baef1bbd6f9327bd6c7ce.svg";